import "./App.css";
import { Provider } from "react-redux";
import store from "./components/Redux/Store";
import Routing from "./routing";
import { PopupWidget } from "react-calendly";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Preloader from "./preLoader";
import ReactGA from "react-ga4";
import * as LaunchDarkly from "launchdarkly-js-client-sdk";
import FeatureFlagContext from "./FeatureFlagContext";

ReactGA.initialize("G-HGF4P4EC9N");

const clientSideId =
  process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID ||
  "6a48caaaa4e0f40ab3d2e611";

function AppShellContent({ featureEnabled = false }) {
  const location = useLocation();
  const isAssistantPage = location.pathname === "/assistant";

  return (
    <FeatureFlagContext.Provider value={{ featureEnabled }}>
      <Provider store={store}>
        <Routing />
        {!isAssistantPage && (
          <div className="schedule">
            <PopupWidget
              url="https://calendly.com/mohanraj-mv-99/30min"
              rootElement={document.getElementById("root")}
              text="📅 Book a call!"
              textColor="#ffffff"
              color="#1d76bc"
            />
          </div>
        )}
      </Provider>
    </FeatureFlagContext.Provider>
  );
}

function AppShell({ featureEnabled = false }) {
  return (
    <Router>
      <AppShellContent featureEnabled={featureEnabled} />
    </Router>
  );
}

function isLocalhostEnvironment() {
  if (typeof window === "undefined") {
    return false;
  }

  const hostname = window.location.hostname;
  return (
    hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1"
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [featureEnabled, setFeatureEnabled] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (!clientSideId) {
      return;
    }

    const ldClient = LaunchDarkly.initialize(clientSideId, {
      kind: "user",
      key: "anonymous",
    });

    ldClient.on("ready", async () => {
      try {
        const flagKey = isLocalhostEnvironment()
          ? "ai-portfolio-assistant-local"
          : "ai-portfolio-assistant";
        const isEnabled = await ldClient.variation(flagKey, false);
        setFeatureEnabled(isEnabled);
      } catch (error) {
        // ignore LaunchDarkly ready errors in production
      }
    });

    ldClient.on("change", async () => {
      try {
        const flagKey = isLocalhostEnvironment()
          ? "ai-portfolio-assistant-local"
          : "ai-portfolio-assistant";
        const isEnabled = await ldClient.variation(flagKey, false);
        setFeatureEnabled(isEnabled);
      } catch (error) {
        // ignore LaunchDarkly change errors in production
      }
    });

    ldClient.on("error", () => {
      // ignore LaunchDarkly client errors in production
    });

    return () => {
      ldClient.close();
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader name="Mohanraj's TechnoTales" />
      ) : (
        <AppShell featureEnabled={featureEnabled} />
      )}
    </>
  );
}

export default App;
